export enum GzTabGroupEvents {
  TAB_CHANGE = 'gzTabChange',
}
